import type { FaireProductEntity } from "../../entity_types/product";

export const p_2axyu8u4mx: FaireProductEntity = {
  token: "p_2axyu8u4mx",
  type: "product",
  name: "MASIL 8 Seconds Salon Hair Mask 200ml",
  brandToken: "b_78a5y9jxe7",
  brandName: "Glowiss",
  imageUrl:
    "https://cdn.faire.com/fastly/6da12a9612792f2da792112a3077a2692b8cbe90826e5b9ee9a86b4897fc0b6d.png",
  galleryImageUrls: [],
  priceDollars: 7.6,
  description:
    "MASIL 8 Seconds Salon Hair Mask delivers Korean innovation in a single step. This dual-action formula targets both scalp and hair simultaneously, absorbing completely in just 8 seconds for busy mornings. Menthol-infused technology cleanses the scalp while controlling oil and reducing hair loss without pore congestion. A blend of 16 natural extracts revitalizes dry, damaged strands and eliminates frizz. The unique transparent-to-creamy texture activates upon water contact, generating heat steam that accelerates nutrient penetration for salon-quality results at home.\n",
  tags: [],
  msrpDollars: 15.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:29.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
